import { render } from "./ParametrosContabilizacion.vue?vue&type=template&id=4a37bd6e"
import script from "./ParametrosContabilizacion.vue?vue&type=script&lang=js"
export * from "./ParametrosContabilizacion.vue?vue&type=script&lang=js"

import "./ParametrosContabilizacion.vue?vue&type=style&index=0&id=4a37bd6e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__